import React from 'react';
import { useRouteError, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

function isChunkError(error: unknown): boolean {
    const msg = (error as any)?.message ?? String(error);
    return (
        msg.includes('Failed to fetch dynamically imported module') ||
        msg.includes('error loading dynamically imported module') ||
        msg.includes('Importing a module script failed')
    );
}

export function RouteErrorBoundary() {
    const error = useRouteError();
    const navigate = useNavigate();
    const chunkError = isChunkError(error);

    const handleReload = () => {
        sessionStorage.removeItem('chunk_reload_attempted');
        window.location.reload();
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="60vh"
            gap={2}
            p={3}
            textAlign="center"
        >
            {chunkError ? (
                <>
                    <Typography variant="h6">A new version is available</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Please refresh to load the latest version.
                    </Typography>
                    <Button variant="contained" onClick={handleReload}>
                        Refresh now
                    </Button>
                </>
            ) : (
                <>
                    <Typography variant="h6">Something went wrong</Typography>
                    <Stack direction="row" spacing={1}>
                        <Button variant="outlined" onClick={() => navigate(-1)}>
                            Go back
                        </Button>
                        <Button variant="outlined" onClick={handleReload}>
                            Reload page
                        </Button>
                    </Stack>
                </>
            )}
        </Box>
    );
}
